import { Add, Search } from '@mui/icons-material';
import {
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { Placeholder, SortableTableHeader, Subheader } from 'components';
import { useNavigation } from 'hooks';
import EarnItem from './EarnItem';
import useEarnItems from 'hooks/useEarnItems';
import { useEffect } from 'react';

const TABLE_HEADERS = [
	{
		value: 'name',
		label: 'Name',
		sortable: false,
		hidden: false
	},

	{
		value: 'item',
		label: 'Type',
		sortable: false,
		hidden: false
	},
	{
		value: 'coins',
		label: 'Coins',
		sortable: false,
		hidden: false
	},
	{
		value: 'xp',
		label: 'XP',
		sortable: false,
		hidden: false
	}
];

const EarnItemsList = () => {
	const { earnItems, isLoading, findEarnItems } = useEarnItems();

	const { handleClick, handleEditClick, handleAddClick } = useNavigation({
		history,
		url: '/earn-items'
	});

	const handleDeleteClick = (earnItem) => {};

	useEffect(() => {
		findEarnItems();
	}, []);

	return (
		<>
			<Subheader title="Earn Items" buttons={[]} />

			<Container maxWidth="lg">
				{!isLoading && earnItems.length > 0 ? (
					<TableContainer component={Paper} elevation={0}>
						<Table>
							<TableHead>
								<TableRow>
									{TABLE_HEADERS.filter((h) => !h.hidden).map((header, idx) => (
										<SortableTableHeader
											key={idx}
											handleSort={() => {}}
											value={`earn-items.${header.value}`}
											sortable={header.sortable}
											sortKey={''}
											sortDirection={''}
										>
											{header.label}
										</SortableTableHeader>
									))}
									<TableCell></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{earnItems.map((earnItem, idx) => (
									<EarnItem
										key={idx}
										earnItem={earnItem}
										handleClick={handleClick}
										handleDeleteClick={handleDeleteClick}
										handleEditClick={handleEditClick}
									/>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				) : (
					<Placeholder
						icon={<Search />}
						title="No Earn Items"
						subtitle="Please try again"
					/>
				)}
			</Container>
		</>
	);
};

export default EarnItemsList;
